<template>
    <div class="project-container">
        <div class="row">
            <div class="left">
                <span>创建时间：</span>
                <el-date-picker v-model="startDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                    placeholder="选择日期">
                </el-date-picker>
                <el-date-picker v-model="endDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                    placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="right">
                <el-input placeholder="请输入内容" v-model="searchStr" class="input-with-select">
                    <el-select v-model="searchType" slot="prepend" placeholder="请选择">
                        <el-option label="项目名称" value="projectName"></el-option>
                        <el-option label="项目编号" value="projectNumber"></el-option>
                    </el-select>
                </el-input>
                <el-button icon="el-icon-search" type="primary" @click="getData">搜 索</el-button>
                <el-button type="primary" @click="initData">重 置</el-button>
            </div>
        </div>
        <el-button type="primary" @click="createProject" class="createBtn"
            v-if="projectTelphoneList.includes(userInfo.telephone)">创 建</el-button>
        <el-table :data="tableData" border style="width: 100%" max-height="780px" :header-cell-style="getTableHeader()"
            stripe v-loading="loadData">
            <el-table-column prop="projectName" label="项目名称" width="180" align="center">
            </el-table-column>
            <el-table-column prop="projectNumber" label="项目编号" width="180" align="center">
            </el-table-column>
            <el-table-column prop="projectEstablishmentTime" label="立项时间" align="center">
            </el-table-column>
            <el-table-column prop="status" label="状态" align="center">
                <template slot-scope="scope">
                    <template v-if="projectTelphoneList.includes(userInfo.telephone)">
                        <el-switch @change="statusChange(scope.row)" v-model="scope.row.myStatus" active-text="启动"
                            inactive-text="草稿">
                        </el-switch>
                    </template>
                    <span v-else :class="scope.row.status === 1 ? 'started' : 'not-started'">{{ scope.row.status === 1 ?
                        '启动' :
                        '草稿' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" @click="editRow(scope.row)">
                        查看
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="page-block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                :page-sizes="[10, 20, 50, 100, 200, 300, 500]" :page-size="size"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <el-dialog title="项目详情" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">
            <el-tabs tab-position="left" class="dialog-box">
                <el-tab-pane label="基本信息">
                    <div class="box">
                        <div class="item">
                            <div class="label">项目名称<span class="required">*</span></div>
                            <ElInputTrim v-model="baseInfo.projectName" :disabled="!canEdit" />
                        </div>

                        <div class="item">
                            <div class="label">项目编号<span class="required">*</span></div>
                            <ElInputTrim v-model="baseInfo.projectNumber" :disabled="!canEdit" />
                        </div>
                        <div class="item">
                            <div class="label">立项时间</div>
                            <el-date-picker v-model="baseInfo.projectEstablishmentTime" format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd" type="date" placeholder="选择日期" :disabled="!canEdit">
                            </el-date-picker>
                        </div>
                        <div class="item w50">
                            <div class="label">项目档案</div>
                            <ElInputTrim v-model="baseInfo.link" :disabled="!canEdit" />
                        </div>
                        <div class="item w50">
                            <a :href="baseInfo.link" target="_blank" class="link">{{ baseInfo.link }}</a>
                        </div>
                        <div class="item w50">
                            <div class="label">项目计划</div>
                            <ElInputTrim v-model="baseInfo.planLink" :disabled="!canEdit" />
                        </div>
                        <div class="item w50">
                            <a :href="baseInfo.planLink" target="_blank" class="link">{{ baseInfo.planLink }}</a>
                        </div>
                        <div class="item w100">
                            <div class="label">项目简介</div>
                            <ElInputTrim :rows="2" type="textarea" v-model="baseInfo.describe" :disabled="!canEdit" />
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="项目人员">
                    <div class="box shop">
                        <div class="select-box">
                            <div class="select-item">
                                <div class="select-label">添加人员</div>
                                <el-select v-model="selectPerson" :disabled="!canEdit" placeholder="请选择" multiple
                                    filterable class="w800" @change="personChange" collapse-tags>
                                    <el-option v-for="item in personOpts" :key="item.uid"
                                        :label="item.userName + '-' + item.telephone" :value="item.uid">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <Editable :headerStyle="getTableHeader()" :showDel="canEdit" :canEdit="canEdit"
                            :value="personList" :header="personHeader" @delRow="personDel">
                        </Editable>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="项目资源">
                    <div class="box">
                        <Editable :headerStyle="getTableHeader()" :showAdd="canEdit" :canEdit="canEdit"
                            :showDel="canEdit" :value="resourceList" :header="resourceHeader" @delRow="resourceDel">
                        </Editable>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="项目店铺">
                    <div class="box shop">
                        <div class="select-box">
                            <div class="select-item">
                                <div class="select-label">公司</div>
                                <el-select :disabled="!canEdit" v-model="selectCompany" placeholder="请选择"
                                    @change="getShopOpts" filterable>
                                    <el-option v-for="item in companyOpts" :key="item.id" :label="item.companyFullName"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="select-item">
                                <div class="select-label">店铺</div>
                                <el-select ref="selectShop" :disabled="!canEdit" v-model="selectShop" placeholder="请选择"
                                    multiple filterable class="w800" v-loading="loadShop" collapse-tags
                                    @change="shopChange">
                                    <el-option v-for="item in shopOpts" :key="item.id"
                                        :label="item.shop_name + '-' + item.sellerId" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <el-table :data="shopList" border style="width: 100%" :header-cell-style="getTableHeader()"
                            stripe>
                            <el-table-column type="index" label="序号" align="center">
                            </el-table-column>
                            <el-table-column :prop="item.prop" :label="item.label" :width="item.width"
                                v-for="item in shopHeader" :key="item.prop" align="center">
                            </el-table-column>
                            <el-table-column prop="address" label="操作" align="center">
                                <template slot-scope="scope">
                                    <el-button type="danger" @click="delRow(scope)" :disabled="!canEdit">移除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="项目财务">项目财务</el-tab-pane>
            </el-tabs>
            <div slot="footer">
                <span class="dialog-footer" v-loading="isSubmit">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="canEdit = true"
                        v-if="dialogId && !canEdit && projectTelphoneList.includes(userInfo.telephone)">编 辑</el-button>
                    <el-button type="primary" @click="submit" v-if="!dialogId || canEdit">保 存</el-button>
                </span>
            </div>

        </el-dialog>
    </div>
</template>

<script>
import { getTableHeader } from '../../assets/js/common.js'
import Editable from '@/components/Editable';
import { ajaxGet, ajaxPost, Baseurl } from '../../api/api/api.js';
import { mapState } from 'vuex';
import ElInputTrim from '@/components/ElInputTrim/index.vue';
export default {
    name: 'Main',
    components: {
        Editable,
        ElInputTrim
    },
    props: {},
    data() {
        return {
            startDate: '',
            endDate: '',
            searchStr: '',
            searchType: 'projectName',
            page: 1,
            size: 10,
            total: 0,
            dialogVisible: false,
            canEdit: false,
            tableData: [],
            baseInfo:{
                projectName: '',
                projectNumber: '',
                projectEstablishmentTime: '',
                link: '',
                describe: '',
                planLink: ''
            },
            dialogId: null,
            personList: [],
            personHeader:[
                { prop: 'userName', label: '姓名'},
                { prop: 'telephone', label: '手机号'},
                { prop: 'roles', label: '角色'},
                { prop: 'function', label: '职能',type: 'input'},
            ],
            resourceList: [],
            resourceHeader: [
                { prop: 'resourceType', label: '资源类型', type: 'input' },
                { prop: 'resourceName', label: '资源名称', type: 'input' },
                { prop: 'resourceUnit', label: '资源单位', type: 'input' },
                { prop: 'resourceQuantity', label: '资源数量', type: 'input', valueType: 'int' },
                { prop: 'resourceUnitPrice', label: '资源单价', type: 'input' },
                { prop: 'allocatedQuantity', label: '已分配数量' },
            ],
            shopList: [],
            shopHeader: [
                { prop: 'platform', label: '平台', type: 'input' },
                { prop: 'shop_name', label: '店铺名称', type: 'input' },
                { prop: 'countryMarks', label: '国家区域', type: 'input' },
                { prop: 'createTime', label: '添加时间', type: 'date', dateType: 'date' },
            ],
            selectCompany: '',
            selectShop: [],
            companyOpts:[],
            shopOpts:[],
            existShopIdMap: {},
            shopMap: {},
            dictionaryMap: {},
            loadShop:false,
            personOpts: [],
            selectPerson: [],
            personMap: {},
            personMapInit: {}, //回显时使用
            loadData: false,
            historyPerson: [], //历史人员列表，为了获取选择时新增或者取消的那一项
            projectTelphoneList: JSON.parse(localStorage.getItem("projectTelphoneList")) || [],
            userInfo: JSON.parse(localStorage.getItem("data")).data.user || [],
            isSubmit: false,
        };
    },
    watch: {},
    computed: {
        ...mapState({
            role: state => state.user.role,
        })
    },
    
    created() {
        // fetch("https://ipinfo.io/json?token=b0d618c422f79c").then(
        //     (response) => response.json()
        // ).then(
        //     (jsonResponse) => console.log(jsonResponse)
        // )

        // fetch('https://ipapi.co/json?access_key=8fe867d9248973b12a17a830b70f10dc').then(
        //     (response) => response.json()
        // ).then(
        //     (jsonResponse) => console.log(jsonResponse)
        // )
        this.getCompanyList(); //获取所有公司
        this.getDictionaryMap(); //获取平台的字典对照表
        this.getPersonList();
    },
    mounted() {
        this.getData();
    },
    methods: {
        formatDate(timestamp) {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        personDel(e){
            this.$confirm('确定删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                if (e.row.id) {
                    const id = e.row.id;
                    const res = await ajaxPost(Baseurl + 'projectController/deleteProjectUser', {id});
                    if(res.status === 200 && res.data.code === 200){
                        const index = this.selectPerson.indexOf(e.row.uid);
                        this.selectPerson.splice(index, 1);
                        this.personList.splice(e.$index, 1);
                        this.$message.success('删除成功');
                    }else{
                        this.$message.error(res.data.data)
                    }
                }else{
                    const index = this.selectPerson.indexOf(e.row.uid);
                    this.selectPerson.splice(index, 1);
                    this.personList.splice(e.$index, 1);
                    this.$message.success('删除成功');
                }
            }).catch(() => {
                
            });
        },
        resourceDel(e){
            this.resourceList.splice(e.$index, 1);
        },
        editRow(d){
            const params = {
                id: d.id,
            }
            ajaxPost(Baseurl + 'projectController/selectProjectDetail', params).then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        const row = res.data;
                        const baseInfo = {};
                        for (let key in row) {
                            if (typeof row[key] !== 'object' && typeof row[key] !== 'function') {
                                baseInfo[key] = row[key];
                            }
                        }
                        this.baseInfo = baseInfo;
                        for (let i = 0; i < row.projectUsers.length; i++) {
                            if (row.projectUsers[i]['roleList']){
                                row.projectUsers[i]['roles'] = row.projectUsers[i]['roleList'].map(role => role.roleName).join(', ');
                                row.projectUsers[i]['acquired'] = true; //已经获取过角色了，后续不再获取
                            }
                            
                            this.$set(this.personMap, row.projectUsers[i]['uid'], row.projectUsers[i])
                        }
                        this.personList = row.projectUsers;
                        this.resourceList = row.projectResourcess;
                        const selectShop = [];
                        const existShopIdMap = {}; //已存在的店铺id
                        if (row.projectSellers && row.projectSellers.length > 0) {
                            this.selectCompany = row.projectSellers[0]['seller']['company_id'];
                            this.getShopOpts(false);
                        }

                        this.shopList = row.projectSellers.map(item => {
                            selectShop.push(item.sellerInfoId);
                            existShopIdMap[item.sellerInfoId] = item.id;
                            this.$set(this.shopMap, item.sellerInfoId, item.seller)
                            return {
                                shop_name: item['shopName'],
                                platform: this.dictionaryMap[item['seller']['sellerType']] ? this.dictionaryMap[item['seller']['sellerType']]['itemTypeName'] : '', //平台
                                countryMarks: item['seller']['countryMarks'] ? item['seller']['countryMarks'].map(item1 => {
                                    return item1.countryName ? item1.countryName : ''
                                }).join('\n') : '', //国家
                                ...item,
                            }
                        });
                        
                        this.selectPerson = row.projectUsers.map(item => item.uid)
                        this.selectShop = selectShop;
                        this.historyPerson = [...this.selectPerson]; //初始化
                        this.dialogId = row.id;
                        this.existShopIdMap = existShopIdMap;
                        this.dialogVisible = true;
                        this.canEdit = false;
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        // 获取所有的人员列表
        getPersonList(){
            ajaxGet(Baseurl + 'projectController/selectUserList').then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        const obj = {};
                        for (let i = 0; i < res.data.length; i++) {
                            obj[res.data[i]['uid']] = {
                                uid: res.data[i]['uid'],
                                userName: res.data[i]['userName'],
                                telephone: res.data[i]['telephone'],
                            }
                        }
                        this.personOpts = res.data;
                        this.personMap = obj;
                        this.personMapInit = JSON.parse(JSON.stringify(obj));
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        getDictionaryMap(){
            ajaxPost(Baseurl + 'purchaseController/selectItemList', { itemCode: 'HYXUN0000014' }).then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        const obj = {};
                        for(let i = 0; i < res.data.length; i++){
                            obj[res.data[i]['itemTypeId']] = res.data[i]
                        }
                        this.dictionaryMap = obj;
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        // 删除店铺
        delRow(e){
            this.$confirm('确定删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                if (e.row.id) {
                    const id = e.row.id;
                    const res = await ajaxPost(Baseurl + 'projectSellerController/deleteProjectSeller', { id });
                    if (res.status === 200 && res.data.code === 200) {
                        this.existShopIdMap[e.row.sellerInfoId] = null;
                        this.shopList.splice(e.$index, 1);
                        const index = this.selectShop.indexOf(e.row.id);
                        this.selectShop.splice(index, 1);
                        this.$message.success('删除成功')
                    } else {
                        this.$message.error(res.data.data)
                    }
                } else {
                    this.shopList.splice(e.$index, 1);
                    const index = this.selectShop.indexOf(e.row.id);
                    this.selectShop.splice(index, 1);
                    this.$message.success('删除成功')
                }
            }).catch(() => {

            });
        },
        // 店铺变化
        shopChange(){
            const result = [];
            for (let id in this.shopMap){ //所有的
                if(this.selectShop.includes(+id)){
                    const row = this.shopMap[id]
                    const item = {
                        shop_name: row['shop_name'],
                        id: this.existShopIdMap[row['id']] ? this.existShopIdMap[row['id']] : null,
                        sellerInfoId: row['id'],
                        platform: this.dictionaryMap[row['sellerType']] ? this.dictionaryMap[row['sellerType']]['itemTypeName'] : '', //平台
                        countryMarks: row['countryMarks'] ? row['countryMarks'].map(item1 => {
                            return item1.countryName ? item1.countryName : ''
                        }).join('\n') : '', //国家
                    }
                    result.push(item);
                }
            }
            this.shopList = result;
        },
        // 人员变化
        async personChange(){
            const obj = this.personMap;
            const added = this.selectPerson.filter(val => !this.historyPerson.includes(val));

            if (added.length && !obj[added[0]]['acquired']) {
                await ajaxPost(Baseurl + 'projectController/selectRoleList', {
                    uid: added[0]
                }).then((resp) => {
                    if (resp.status === 200) {
                        const res = resp.data;
                        if (res.code === 200) {
                            this.$set(obj[added[0]], 'roles', res.data.map(item => item.roleName).join(', '));
                        } else {

                        }
                        this.$set(obj[added[0]], 'acquired', true); //已经获取过角色了，后续不再获取
                    }
                })
            }
            
            const arr = [];
            for(let i = 0; i < this.selectPerson.length; i++){
                arr.push(obj[this.selectPerson[i]])
            }
            this.personList = arr;
            this.historyPerson = [...this.selectPerson]; //更新历史人员列表
        },
        // 状态改变
        statusChange(row){
            const params = {
                id: row.id,
                status: row.myStatus ? 1 : 0
            }
            ajaxPost(Baseurl + 'projectController/updateProjectStatus', params).then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        this.$message.success('修改成功');
                        this.$set(row, 'status', params['status'])
                    } else {
                        this.$message.error(res.message);
                    }
                }
                this.loadShop = false;
            })
        },
        getCompanyList(){
            ajaxPost(Baseurl + 'companyController/selectAllSubsidiaryCompanyList').then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        this.companyOpts = res.data;
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        getShopOpts(isFocus = true){
            this.shopOpts = [];
            this.loadShop = true;
            ajaxPost(Baseurl + 'projectSellerController/selectSellerList', {
                company_id: this.selectCompany
            }).then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        this.shopOpts = res.data;
                        const d = res.data;
                        for(let i = 0; i < d.length; i++){
                            this.$set(this.shopMap, d[i]['id'], d[i]);
                        }
                        if (isFocus){
                            this.$nextTick(() => {
                                this.$refs.selectShop.focus();
                                this.$refs.selectShop.toggleMenu();
                            })
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                }
                this.loadShop = false;
            })
        },
        initData(){
            this.startDate = '';
            this.endDate = '';
            this.searchStr = '';
            this.page = 1;
            this.size = 10;
            this.searchType = 'projectName';
            this.getData();
        },
        getData(){
            this.loadData = true;
            const params = {
                "page": this.page,
                "size": this.size,
                uid: this.role.uid,
            }
            if (this.startDate){
                params['startTime'] = this.startDate + " 00:00:00"
            }
            if (this.endDate) {
                params['endTime'] = this.endDate + " 23:59:59"
            }
            if(this.searchStr){
                params['searchType'] = this.searchType;
                params['searchStr'] = this.searchStr;
            }
            ajaxPost(Baseurl + 'projectController/selectProjectList', params).then((resp)=>{
                if (resp.status === 200){
                    const res = resp.data;
                    if(res.code === 200){
                        const data = res.data;
                        this.tableData = data.list.map(item => {
                            return {
                                ...item,
                                myStatus: item.status === 1
                            }
                        });
                        this.total = data.total;
                    }else{
                        this.$message.error(res.message);
                    }
                }
                this.loadData = false;
            })
        },
        // 基础信息保存
        submit(){
            if (!this.baseInfo.projectName) {
                this.$message.error('请填写项目名称！');
                return
            }
            if (!this.baseInfo.projectNumber) {
                this.$message.error('请填写项目编号！');
                return
            }
            this.isSubmit = true;
            const params = {
                ...this.baseInfo,
                createUid: this.role.uid,
                projectUsers: this.personList,
                projectResourcess: this.resourceList,
                projectSellers: this.shopList,
            }
            let text = '新建';
            let api = 'insertProject';
            if (this.dialogId){
                params['id'] = this.dialogId;
                text = '修改';
                api = 'updateProject'
            }
            ajaxPost(Baseurl + 'projectController/' + api, params).then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        // this.dialogId = res.data;
                        this.$message.success(text + '成功！');
                        this.dialogVisible = false;
                        this.clearDialogData();
                        this.getData();
                    } else {
                        this.$message.error(res.message);
                    }
                }
                this.isSubmit = false;
            })
        },
        clearDialogData(){
            this.personList = [];
            this.resourceList = [];
            this.shopList = [];
            this.selectCompany = '';
            this.dialogId = null;
            this.selectPerson = [];
            this.selectShop = [];
            this.existShopIdMap = {};
            this.baseInfo = {};
            this.canEdit = false;
            this.personMap = this.personMapInit;
        },
        handleClose(){
            this.clearDialogData();
            this.dialogVisible = false;
        },
        getTableHeader,
        handleSizeChange(val) {
            this.page = 1;
            this.size = val;
            this.getData();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getData();
        },
        createProject(){
            this.canEdit = true;
            this.dialogVisible = true
        }
    },
};
</script>
<style lang="scss" scoped>
.row{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .left, .right{
        display: flex;
        align-items: center;
    }
    /deep/ .el-date-editor{
        margin: 0 5px;
    }
    .right {
        .el-button{
            margin-left: 10px;
        }
        .el-select{
            width: 120px;
        }
    }
}
.dialog-box{
    .box{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
        .item{
            width: 30%;
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            .label{
                width: 80px;
            }
            .el-input, .el-textarea{
                flex: 1;
            }
            &.w100{
                width: 100%;
            }
            &.w50{
                width: calc(50% - 10px);
            }
        }
        &.shop{
            display: block;
            .select-box{
                display: flex;
                .select-item{
                    display: flex;
                    align-items: center;
                    margin-right: 10px;
                    .select-label{
                        margin-right: 5px;
                    }
                    .el-select{
                        width: 250px;
                        &.w800{
                            width: 800px;
                        }
                    }
                }
            }
        }
    }
}
/deep/ .el-tabs__content{
    max-height: 500px;
}
.el-tab-pane{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: auto;
    .editable-container{
        width: 100%;
    }
    .box{
        width: 100%;
        max-height: 465px;
        overflow: auto;
    }
    .last-button{
        margin-top: 5px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
.started{
    background-color: #70b603;
    color: #fff;
    padding: 0 5px;
    border-radius: 5px;
    display: inline-block;
}
.not-started {
    background-color: #f5f5f5;
    color: #999;
    padding: 0 5px;
    border-radius: 5px;
    display: inline-block;
}
.page-block{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
}
.createBtn{
    margin: 10px 0;
}
.link{
    color: #409eff;
    text-decoration: none;
    &:hover{
        text-decoration: underline;
    }
}
</style>